import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import getLang from 'I18n/utils/getLang';
import { H2 } from 'UIComponents/elements/headings';
import Small from 'UIComponents/elements/Small';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import UISelect from 'UIComponents/input/UISelect';
import { CUSTOMER_SUPPORT_LANGUAGES } from 'ecosystem-marketplace-core/constants/Languages';
import { LANGUAGE } from '../../../constants/search/FilterKey';
/* @ts-expect-error module is untyped */

import { translateFilterValue } from '../../../utils/i18n';
import { WIZARD_STEP_CLASSNAME, WIZARD_STEP_HEIGHT } from './FindPartnerWizard';
export default function FindPartnerWizardLanguageStep({
  filters,
  onFilterChange
}) {
  const guessLang = getLang();
  const [guessed, setGuessed] = useState(null);
  useEffect(() => {
    if (!filters.language.length && guessed === null) {
      onFilterChange('language', [guessLang]);
      setGuessed(true);
    }
  }, [filters.language, guessLang, guessed, onFilterChange]);
  const options = useMemo(() => CUSTOMER_SUPPORT_LANGUAGES.map(lang => ({
    text: translateFilterValue(LANGUAGE, lang),
    value: lang
  })), []);
  return /*#__PURE__*/_jsxs(UIWizardStep, {
    className: WIZARD_STEP_CLASSNAME,
    style: {
      height: WIZARD_STEP_HEIGHT
    },
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-11",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.language.title"
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      anchorType: "combined",
      multi: true,
      onChange: ({
        target: {
          value
        }
      }) => {
        onFilterChange('language', value);
        setGuessed(false);
      },
      options: options,
      value: filters.language
    }), guessed && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    })]
  });
}